<template>
  <div :style="{ zIndex: 500, top: 0, left: 0 }" class="subtitles">
    <h3 class="captionsSettingsHeader">{{ $t("player.subtitleSetting") }}</h3>
    <ul class="languages">
      <li
        tabindex="0"
        v-for="(track, index) in textTracks"
        :key="track.src"
        class="language"
        @click="setTextTrack(track, index)"
        @keyup.enter="setTextTrack(track, index)"
        :class="{
          selected:
            track.selected ||
            (index === 0 && !textTracks.some((t) => t.selected)),
        }"
      >
        {{
          !index || !track.srclang
            ? track.label
            : $t(`language.${track.srclang}`)
        }}
      </li>
    </ul>
    <button class="TxTTrackSettings"></button>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import en from "../../../i18n/en_US";
import fr from "../../../i18n/fr_FR";

import { SVG } from "@/components/utils/const";
export default defineComponent({
  name: "subtitles-modal",
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  components: {},
  props: {
    tracks: {
      required: true,
      type: Array,
    },
    player: {
      required: true,
      type: Object,
    },
    showSubtitlesModal: {
      required: true,
      type: Function,
    },
  },

  data() {
    return {
      textTracks: [],
      textTrack: {},
    };
  },

  methods: {
    setTextTrack(textTrack, index) {
      const videoJSElement = document.querySelector(".video-js");
      if (videoJSElement) {
        videoJSElement.classList.remove("vjs-no-default-cc");
      }

      this.player.textTracks().tracks_.forEach((track) => {
        track.mode = "hidden";
        if (track.src === textTrack.src) {
          track.mode = "showing";
        }
      });
      const previousSelectedTrack = this.textTracks.find(
        (track) => track.selected
      );
      if (previousSelectedTrack) {
        previousSelectedTrack.selected = false;
      }
      textTrack.selected = true;
      this.showSubtitlesModal();
      const ccIcon = document.querySelector(
        ".vjs-control.vjs-button.customSubsButton"
      );
      if(ccIcon){
      if (index !== 0) {
        if (textTrack.src) {
                        ccIcon.innerHTML = SVG.CLOSED_CAPTIONS_ON;
        }
      } else {
                        ccIcon.innerHTML = SVG.CLOSED_CAPTIONS_OFF;
      }
      }

    },
    OpenTextTrackModal() {
      const modalClass = document.querySelector(
        ".vjs-modal-dialog.vjs-hidden.vjs-text-track-settings"
      );
      if (modalClass) {
        this.showSubtitlesModal();
        modalClass.classList.remove("vjs-hidden");
      }
    },
    CloseSettingModal() {
      const modalClass = document.querySelector(
        ".vjs-modal-dialog.vjs-text-track-settings"
      );
      if (modalClass) {
        modalClass.classList.add("vjs-hidden");
      }
    },
  },

  mounted() {
    const subModal = document.querySelector(".subtitles");
    const existingPlaylist = document.querySelector(".playlist-container");
    if (existingPlaylist) {
      subModal.style.width = "80%";
    }
    this.textTracks = this.tracks;
    const TxTTrackSettings = document.querySelector(".TxTTrackSettings");
    if (TxTTrackSettings) {
      TxTTrackSettings.innerHTML = SVG.SETTINGS_TEXT_TRACK;
      TxTTrackSettings.addEventListener("click", this.OpenTextTrackModal);
    }
    const CloseBtn = document.querySelector(
      ".vjs-close-button.vjs-control.vjs-button"
    );
    if (CloseBtn) {
      CloseBtn.addEventListener("click", this.CloseSettingModal);
    }
    const DoneBtn = document.querySelector(".vjs-done-button");
    if (DoneBtn) {
      DoneBtn.addEventListener("click", this.CloseSettingModal);
    }
  },
  watch: {
    textTracks: {
      handler(newTextTracks) {
        const changeTrackTxTDisplay = document.querySelector(
          ".vjs-text-track-display"
        );
        if (newTextTracks.length > 0 && newTextTracks[0].selected) {
          changeTrackTxTDisplay?.classList.add("vjs-hidden");
        } else {
          changeTrackTxTDisplay?.classList.remove("vjs-hidden");
        }
      },
      immediate: true,
      deep: true,
    },
  },
});
</script>

<style scoped>
.subtitles {
  display: flex;
  justify-content: center;
  flex-direction: column;
  color: var(--vm-color-three);
  align-items: center;
  width: 100%;
  height: 100%;
  background: var(--vm-color-one-08);
  position: fixed;
}

.captionsSettingsHeader {
  padding: 7px 12px;
  text-align: center;
  border-bottom: 1px solid gray;
  width: 20%;
  margin-left: 40px;
}

.languages {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  list-style: none;
  width: 20%;
}

.selected {
  background-color: var(--vm-color-two-08);
}

.language {
  border: 1px solid var(--vm-color-two-08);
  border-radius: 7px;
  padding: 7px 12px;
  color: var(--vm-color-three);
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  width: 100%;
  text-align: center;
}

.language:not(:last-child) {
  margin-bottom: 5px;
}

.language:hover {
  background-color: var(--vm-color-two-08);
  color: var(--vm-color-three);
}

@media (max-width: 1500px) {
  .languages {
    width: 100%;
    margin-right: 40px;
  }

  .language {
    width: 70%;
  }

  .captionsSettingsHeader {
    width: 70%;
    margin-right: 40px;
  }
}

.TxTTrackSettings {
  margin-top: 1%;
  margin-left: 17%;
  cursor: pointer;
}
</style>
